import { FilterHelperValues } from 'components/FilterCheckBox';

export function getDefaultGroup(filterHelper: FilterHelperValues[]): Array<string> {
  let group: Array<string> = [];
  filterHelper.forEach((i) => {
    if (i.default && i.group) {
      group = i.group;
    }
  });
  return group;
}
